import { resolveNavigatorRouteFromHref } from './repository/navigator';

function hideBrandingHeader(doc) {
  const header = doc.querySelector('header');
  if (!header) return;
  const functional = header.querySelector(
    'input, select, textarea, button, .progress, .progress-wrap, form'
  );
  if (functional) return;
  header.setAttribute('data-kc-hidden-brand', 'true');
  header.style.display = 'none';
}

function rewriteAnchors(doc) {
  doc.querySelectorAll('a[href]').forEach((anchor) => {
    const route = resolveNavigatorRouteFromHref(anchor.href);
    if (!route) return;
    anchor.setAttribute('href', route);
    anchor.setAttribute('target', '_parent');
    anchor.setAttribute('data-kc-site-link', 'true');
  });
}

export function connectPackageFrame(iframe, onNavigate) {
  const doc = iframe?.contentDocument;
  if (!doc?.documentElement) return () => {};

  hideBrandingHeader(doc);
  rewriteAnchors(doc);

  const onClick = (event) => {
    const anchor = event.target?.closest?.('a[href]');
    if (!anchor) return;
    const route = resolveNavigatorRouteFromHref(anchor.href);
    if (!route) return;
    event.preventDefault();
    onNavigate(route);
  };

  doc.addEventListener('click', onClick, true);

  return () => {
    doc.removeEventListener('click', onClick, true);
  };
}
